<template>
    <ContentOrLoading>
        <div v-if="!loading">
            <CuentaAtras @tiempoTerminado="tiempoTerminado()" />
            <PageTitle title="Productos" />
            <CabeceraClubs v-if="evento.equipo_local" :event="evento" />
            <CabeceraImagen v-if="!evento.equipo_local" :event="evento" class="mb-4" />

            <Stepper 
                ref="stepper"
                :steps="steps" 
                :evento="evento" 
            >
                <template #pasoProductos="{ containerRef, changeStep }">
                    <div class="container">
                        <div class="row">
                            <div class="col-12 mb-3">
                                <ListadoProductosComponent 
                                    :productos="productosAnadidos"
                                    :desactivar="false"
                                    :evento_id="evento.id" 
                                />
                            </div>
                        </div>
                    </div>
                    <CarritoEvento
                        :containerRef="containerRef"
                        :plazas="[]"
                        :asientos="[]"
                        :carrito_id="carrito_id"
                        :productos="productosCarrito"
                        :productosListado.sync="productosAnadidos"
                        :stickyMargin="-10"
                        :evento="evento"
                        :session_id="sesion_id"
                        @changeStep="changeStep"
                    />
                </template>
                <template #pasoDatos="{changeStep}">
                    <div class="container">
                        <div class="row">
                            <div class="col-12 mb-3">
                                <DatosCompradorProductos 
                                    :datos_comprador="datos_comprador"
                                    :fields="evento.fields"
                                    :productos="productosCarrito"
                                    :session_id="sesion_id"
                                    :session_id_carrito="session_id_carrito"
                                    :jet_id.sync="jet_id"
                                    :formulario.sync="formulario"
                                    @changeStep="changeStep"
                                />
                            </div>
                        </div>
                    </div>
                </template>
                <template #pasoResumen="{changeStep}">
                    <div class="container">
                        <div class="row">
                            <div class="col-12 mb-3">
                                <ResumenCompraComponent 
                                    :entradas="[]" 
                                    :formulario="formulario" 
                                    :event="evento"
                                    :datos="datos_comprador"
                                    :productos="productosCarrito"
                                    :session_id="session_id_carrito"
                                    :entradasPlazas="[]"
                                    :sectores="[]"
                                    :desactivar="false"
                                    @terminar="guardarDatos" 
                                    @terminado="changeStep"
                                    @volver="changeStep(true)"
                                />
                            </div>
                        </div>
                    </div>
                </template>
                <template #pasoPago>
                    <div class="container">
                        <div class="row">
                            <div class="col-12 mb-3">
                                <PagoPaycometComponent
                                    ref="pago"
                                    tipo_venta="evento"
                                    :jet_id="jet_id"
                                    :session_id="session_id_carrito"
                                />	
                            </div>
                        </div>
                    </div>
                </template>
            </Stepper>
        </div>
    </ContentOrLoading>
</template>

<script>
    import PageTitle from '@/components/frontend/shared/PageTitle';
    import CuentaAtras from '@/components/frontend/events/compra/CuentaAtras';
    import Stepper from '@/components/frontend/events/compra/components/Stepper.vue';
    import CarritoEvento from '@/components/frontend/events/compra/components/CarritoEvento.vue';
    import DatosCompradorProductos from '@/components/frontend/productos/DatosCompradorProductos.vue';
    import ResumenCompraComponent from '@/components/frontend/events/compra/ResumenCompraComponent.vue';
    import PagoPaycometComponent from '@/components/frontend/compra/components/PagoPaycometComponent.vue';
    import ListadoProductosComponent from '@/components/frontend/events/compra/components/productos/ListadoProductosComponent.vue';
    import CabeceraClubs from '@/components/frontend/events/show/CabeceraClubs';
    import CabeceraImagen from '@/components/frontend/events/show/CabeceraImagen';

    export default {
        props: {
            slug: {
                type: String,
                required: true
            },
            sesion_id: {
                type: [Number, String],
                required: true
            }
        },
        data() {
            return {
                loading: false,
                evento: null,
                carrito_id: null,
                session_id_carrito: null,
                loadingStepper: false,
                productosCarrito: [],
                productosAnadidos: [],
                datos_comprador: {},
                jet_id: null,
                formulario: null,
            }
        },
        methods: {
            getEvento() {
                this.loading = true;

                const params = {
                    filters: {
                        tid: this.teatro.hash
                    },
                    slug: this.slug
                }
        
                this.$store.dispatch(this.config.getVuexAlias('front.productos.evento'), params).then(res => {
                    this.evento = res.data.data;
                }).catch(error => {
                    this.$router.push({ name: '404page' });
                }).finally(() => {
                    this.loading = false;
                });
            },
            iniciarCarrito() {
                const params = {
                    filters: {},
                    slug: this.slug,
                    sesion_id: this.sesion_id
                };

                this.$store.dispatch(this.config.getVuexAlias('front.productos.crear-carrito'), params).then(res => {
                    this.carrito_id = res.data.data.id;
                    this.session_id_carrito = res.data.data.session_id;
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                });
            },
            tiempoTerminado() {
                const params = {
                    filters: {},
                    session_id: this.session_id
                };

                this.$store.dispatch(this.config.getVuexAlias('front.borrar.sesion'), params).then(res => {
                    window.location.reload();
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                });
            },
            guardarDatos() {
                this.loadingStepper = true;
                const params = {
                    filters: {
                        sesion_id: this.sesion_id,
                        tid: this.teatro.hash
                    },
                    datos_compradores: this.datos_comprador,
                    session_id: this.session_id_carrito
                }
                this.$store.dispatch(this.config.getVuexAlias('front.guardar.datos.comprador'), params).then(res => {
                    this.jet_id = res.data.jet_id;
                    this.formulario = res.data.formulario;
                    this.$toast.success('Datos guardados correctamente');
                    this.$nextTick(() => {
                        if (this.$refs.stepper) {
                            this.$refs.stepper.changeStep();
                        }
                    });
                }).finally(() => this.loadingStepper = false); 
            },
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            },
            steps() {
                return [
                    { label: this.$t('productos.elige_productos'), slot: "pasoProductos" },
                    { label: this.$t('productos.completar_datos'), slot: "pasoDatos" },
                    { label: this.$t('productos.resumen_compra'), slot: "pasoResumen" },
                    { label: this.$t('productos.pago'), slot: "pasoPago" }
                ]
            }
        },
        created() {
            this.getEvento();
            this.iniciarCarrito();
        },
        components: {
            PageTitle, CuentaAtras, Stepper, CarritoEvento, DatosCompradorProductos, ListadoProductosComponent, ResumenCompraComponent, PagoPaycometComponent, CabeceraClubs, CabeceraImagen
        }
    }
</script>